// Module
var code = "<style>:host{height:100%;width:100%;display:flex;flex-direction:column}</style> <div id=\"wrapper\"> <div id=\"pre-check\"></div> <div id=\"post-check\"></div> </div> <template id=\"check-row\"> <div class=\"row-wrapper\"> <div id=\"check-title\"></div> </div> </template>";
// Exports
export default code;